import React from 'react';
import { AdminHub } from './views/admin-hub';
import { ContentSettingsMainWrapper } from '@web/content-settings/content-settings-main-wrapper';
import { ContentSettingsProvider } from '@packages/contexts/content-settings';
import { ContentSettingsQmrsDashboardMain } from '@web/content-settings/content-settings-main-qmrs-dashboard';
import { contentSettingsService, synonymsService } from '@web/services/singletons';
import { ContentSettingsTechline } from '@web/content-settings/content-settings-techline';
import { ContentSettingsTechshare } from '@web/content-settings/content-settings-techshare';
import { ModuleName } from '@web/core/navigation/module-name';
import { EntityDetail } from './views/entity-detail';
import { EntityForm } from './views/entity-form';
import { FailCodeTeams } from './views/fail-code-teams';
import { FeedbackDetail } from './views/feedback-detail';
import { FeedbackFormBuilder } from './views/feedback-form-builder';
import { ManageEntities } from './views/manage-entities';
import { ManageDsqmsReassignment } from './views/manage-dsqms';
import { ManageFeedback } from './views/manage-feedback';
import { ManageRetailers } from './views/manage-retailers';
import { ManageUsers } from './views/manage-users';
import { ManageWorksheets } from './views/worksheets';
import { RetailerDetail } from './views/retailer-detail';
import { RetailerForm } from './views/retailer-form';
import { StisPublications } from '@web/vin-sessions/components/stis-publications/stis-publications';
import { Synonyms } from './views/synonyms';
import { SynonymsProvider } from '@packages/contexts/synonyms';
import { TouchbookAttachments } from './views/toughbook-attachments';
import { WorksheetDetail } from './views/worksheets/worksheet-detail/worksheet-detail';
import { WorksheetsForm } from './views/worksheets/worksheet-form/worksheets-form';
import NoMatch from '@web/views/no-match';
import StisPublicationForm from '@web/vin-sessions/components/stis-publications/stis-publication-form';
import WorksheetPreview from './views/worksheets/worksheet-preview/worksheet-preview';
import { ManageAdminReports } from './views/manage-admin-reports';

export type AdministrationRoute = {
    path?: string;
    index?: boolean;
    element: React.ReactNode;
    moduleName?: ModuleName;
};

export const administrationRoutes: AdministrationRoute[] = [
    { index: true, element: <AdminHub />, moduleName: ModuleName.AdminHub },
    { path: 'content-settings', element: <ContentSettingsMainWrapper />, moduleName: ModuleName.AdminContentSettings },
    {
        path: 'content-settings/qmrsdashboard',
        element: <ContentSettingsQmrsDashboardMain />,
        moduleName: ModuleName.AdminContentSettings,
    },
    {
        path: 'content-settings/techline',
        element: (
            <ContentSettingsProvider service={contentSettingsService}>
                <ContentSettingsTechline />
            </ContentSettingsProvider>
        ),
        moduleName: ModuleName.AdminContentSettings,
    },
    {
        path: 'content-settings/techshare',
        element: <ContentSettingsTechshare />,
        moduleName: ModuleName.AdminContentSettings,
    },
    { path: 'dsqmsReassignment', element: <ManageDsqmsReassignment />, moduleName: ModuleName.AdminDsqmsReassignment },
    { path: 'adminReports', element: <ManageAdminReports />, moduleName: ModuleName.AdminReports },
    { path: 'entities', element: <ManageEntities />, moduleName: ModuleName.AdminEntities },
    { path: 'entities/:entityId', element: <EntityDetail />, moduleName: ModuleName.AdminEntities },
    { path: 'entities/:entityId/edit', element: <EntityForm />, moduleName: ModuleName.AdminEntities },
    { path: 'entities/new', element: <EntityForm />, moduleName: ModuleName.AdminEntities },
    { path: 'fail-code-teams', element: <FailCodeTeams />, moduleName: ModuleName.AdminFailCodeTeams },
    { path: 'feedback', element: <ManageFeedback />, moduleName: ModuleName.AdminFeedback },
    { path: 'feedback/:feedbackFormId', element: <FeedbackDetail />, moduleName: ModuleName.AdminFeedback },
    { path: 'feedback/:feedbackFormId/edit', element: <FeedbackFormBuilder />, moduleName: ModuleName.AdminFeedback },
    { path: 'feedback/edit/:feedbackFormId', element: <FeedbackFormBuilder />, moduleName: ModuleName.AdminFeedback },
    { path: 'feedback/new', element: <FeedbackFormBuilder />, moduleName: ModuleName.AdminFeedback },
    {
        path: 'publication/:publicationFormId',
        element: <StisPublicationForm />,
        moduleName: ModuleName.AdminPublications,
    },
    { path: 'publication/new', element: <StisPublicationForm />, moduleName: ModuleName.AdminPublications },
    { path: 'publications', element: <StisPublications />, moduleName: ModuleName.AdminPublications },
    { path: 'retailers', element: <ManageRetailers />, moduleName: ModuleName.AdminRetailers },
    { path: 'retailers/:retailerId', element: <RetailerDetail />, moduleName: ModuleName.AdminRetailers },
    { path: 'retailers/:retailerId/edit', element: <RetailerForm />, moduleName: ModuleName.AdminRetailers },
    {
        path: 'synonyms',
        element: (
            <SynonymsProvider synonymsService={synonymsService}>
                <Synonyms />
            </SynonymsProvider>
        ),
        moduleName: ModuleName.AdminSynonyms,
    },
    {
        path: 'toughbook-attachments',
        element: <TouchbookAttachments />,
        moduleName: ModuleName.AdminToughbookAttachments,
    },
    { path: 'users', element: <ManageUsers />, moduleName: ModuleName.AdminUsers },
    { path: 'worksheet/:worksheetFormId', element: <WorksheetDetail />, moduleName: ModuleName.AdminWorksheets },
    { path: 'worksheet/:worksheetFormId/edit', element: <WorksheetsForm />, moduleName: ModuleName.AdminWorksheets },
    { path: 'worksheet/new', element: <WorksheetsForm />, moduleName: ModuleName.AdminWorksheets },
    { path: 'worksheet/preview/:worksheetId', element: <WorksheetPreview />, moduleName: ModuleName.AdminWorksheets },
    { path: 'worksheets', element: <ManageWorksheets />, moduleName: ModuleName.AdminWorksheets },
    { path: '*', element: <NoMatch /> },
];
